import type { SpecificationState } from '../types/specification';
import type { Event } from '@patsnap/tahiti-core/common/event';
import type { SpecificationStep } from '../enums';

export const SpecificationService = Symbol.for('SpecificationService');

/**
 * 说明书生成公共服务
 * 1. 调度步骤切换
 * 2. 状态清理
 */
export interface SpecificationService {
    readonly onSpecificationStateChange: Event<SpecificationState>;
    readonly onIsReadyChange: Event<boolean>;

    /** 获取状态 */
    getState(): SpecificationState;

    /**
     * 初始化, 如果内部状态已准备好, 则直接返回
     * 获取当前步骤
     * @param taskId 任务ID
     */
    init(taskId: string): Promise<void>;

    /** 是否已准备好 */
    isReady(): boolean;

    /** 切换步骤 */
    switchStep(step: SpecificationStep): void;
}
